import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import router from "./router/router";
import App from "./App.vue";
import axios from "axios/dist/browser/axios.cjs";
import "@/assets/font/font.css";
import { ElMessage } from "element-plus";

const app = createApp(App);
app.use(ElementPlus).use(router);
app.config.globalProperties.$message = ElMessage;
app.mount("#app");

axios.interceptors.request.use((config) => {
  // 为请求头对象，添加Token验证的token字段
  const token = localStorage.getItem("m-token");
  if (token) {
    config.headers["m-token"] = token;
  }
  return config;
});

axios.interceptors.response.use((res) => {
  if (res.data.code === 403) {
    localStorage.removeItem("m-token");
    ElMessage.warning("登录有效期已过，麻烦重新登录下啦");
    router.replace({
      path: "/login",
      query: { redirect: router.currentRoute.value.fullPath }, // 登录成功后跳回当前页面
    });
  }
  return res;
});
